import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "field-set-required-one-true",
  templateUrl: "./field-set-required-one-true.component.html",
})
export class FieldSetRequiredOneTrueComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
